import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="quiz-navigation"
// Handles navigation between quiz questions using backOne/forwardOne logic
export default class extends Controller {
  back(event) {
    event.preventDefault()
    if (!window.currentQuestion) return

    const current = window.currentQuestion.number
    if (current == 1) {
      return
    }
    const previous = current - 1

    const clickThisBubble = window.$(
      "#interface-bottom-current-bubble-" + previous + "-yash"
    ).parent()
    clickThisBubble.click()
  }

  forward(event) {
    event.preventDefault()
    if (!window.currentQuestion) return

    const current = window.currentQuestion.number
    const lastQuestionNumber = window.$(".interface-bottom-bubble-yash").length
    if (current == lastQuestionNumber) {
      return
    }
    const next = current + 1

    const clickThisBubble = window.$(
      "#interface-bottom-current-bubble-" + next + "-yash"
    ).parent()
    clickThisBubble.click()
  }
}
